import { render } from "./TheLanguageCreator.vue?vue&type=template&id=b84df4c6"
import script from "./TheLanguageCreator.vue?vue&type=script&lang=js"
export * from "./TheLanguageCreator.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__